import { Button as AntButton } from 'antd'

export default function Button ({ className, ...props }) {
  return <AntButton type='primary' {...props}>{props.children}</AntButton>
}
